import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const user_detailScreenModule = defineScreen({
  app: "coaching",
  screen_id: "user-detail",
  path: "/users/:user_id",
  params: ["user_id"],
  heading: { text: "Users", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "allow",
    "coach": "deny",
    "company_admin": "deny",
    "participant": "deny",
    "cohort_lead": "deny"
  },
  states: ["ready"],
  actions: [
    { id: "load", kind: "secondary", driver: "detail.load" }
  ],
  recipe: "Detail-1",
  data: { seedNeeds: ["readonly-walk-session", "populated-list-min1"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/user-detail.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default user_detailScreenModule;
